import { cn } from '@servicetim/ui/lib';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

/** Link to a ticket by key (or id); stops row-click handlers from firing twice. */
export function TicketKeyLink({
  ticketKey,
  children,
  className,
}: {
  ticketKey: string;
  children?: ReactNode;
  className?: string;
}) {
  return (
    <Link
      to="/tickets/$idOrKey"
      params={{ idOrKey: ticketKey }}
      className={cn('font-medium font-mono text-accent text-sm hover:underline', className)}
      onClick={(event) => event.stopPropagation()}
    >
      {children ?? ticketKey}
    </Link>
  );
}
